import React from 'react';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Paper from '@material-ui/core/Paper';
export const TransitionModal = (props) => {
    const { children, isOpen, size = 'large', onClose } = props;
    return (React.createElement(SModal, { open: isOpen, onClose: onClose, closeAfterTransition: true, BackdropComponent: Backdrop, BackdropProps: {
            timeout: 500,
        } },
        React.createElement(Fade, { in: isOpen },
            React.createElement(SPaper, { size: size }, children))));
};
const SModal = styled(Modal) `
  border: transparent;
  border-radius: 10px;
  overflow: scroll;
`;
const SPaper = styled(Paper) `
  width: 80%;
  @media (min-width: 600px) {
    width: ${({ size }) => (size === 'large' ? '80%' : '40%')};
  }
  margin: 36px auto 36px auto;
  padding: 32px;
  background-color: #fff;
  border: transparent;
  border-radius: 10px;
  &:focus {
    outline: transparent;
  }
`;
